import useSWR from "swr";
import {ProfileType} from "features/login/types";
import {useAuth} from "features/login/context/AuthProvider";
import {UserEnum} from "shared/types";
import {isBrowser} from "shared/lib/fns";
import {queries} from "shared/api/queries";

const emptyProfile: ProfileType = {
  dob: "",
  permission_group: [],
  fullname: "",
  is_available: false,
  ride_type: "",
  helmet_verified: false,
  uuid: "",
  email: "",
  locale: "",
  phonenumber: "",
  username: "",
  type: UserEnum.STAFF,
  gender: "",
  res_seq: "",
  damagedCount: 0,
  boxCount: 0,
  hubCount: 0,
  unitCount: 0,
  invoicePendingCount: 0,
  sector: [],
};

const getInitialProfile = () => {
  if (!isBrowser() || !window.Cypress || !window.initialState?.profile) {
    return emptyProfile;
  }
  
  return {
    ...emptyProfile, ...window.initialState.profile,
  };
};

export const useProfile = () => {
  const {authenticated} = useAuth();
  const {
          data: user, isLoading, error
        } = useSWR<ProfileType>(authenticated ? queries.user : null, {
    fallbackData: getInitialProfile(), revalidateOnFocus: false, shouldRetryOnError: false,
  });
  
  return {
    profile: authenticated ? user ?? emptyProfile : emptyProfile,
    isLoadingProfile: authenticated ? isLoading : false,
    profileError: error
  };
};
